import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { Typography, Tooltip, IconButton, Fab, withStyles } from '@material-ui/core';
import { Refresh, Add } from '@material-ui/icons';
import MaterialTable from 'material-table';
import { MuiTableRows } from '../../../../themes';
import { BackButton, hasPermission, localization, getDimensionsOfPagination } from '../../../sc-utilities';
import * as actions from '../store/prepaidBalanceActions';
import * as action from '../../../np-core/Auth/store/authActions';

const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16
    },
    customToolbar: {
        marginTop: 9,
        marginLeft: 14,
        width: "900px"
    }
});

let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const windowHeight = 200;

const TopupHistoryList = props => {
    const { classes, translations, saveColumnsFilter, onTopupList, onTopupCount, activeCustomerID, activeAccountID, tableColumns, permissions, redirectHandler, tableRef } = props;

    const columnObject = useMemo(() => tableColumns, [tableColumns]);

    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: true,
        search: false,
        minBodyHeight: window.innerHeight - windowHeight < 300 ? 300 : window.innerHeight - windowHeight,
        maxBodyHeight: window.innerHeight - windowHeight,
        pageSizeOptions: rowsPageSizeInit,
        exportButton: false,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
        },
        columnsButton: true,
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: true
    });

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    const fetchTableData = async query => {
        let q = filterQuery(query.filters);
        query['ActiveCustomerID'] = activeCustomerID;
        query['ActiveAccountID'] = activeAccountID;
        q['Username'] = q.CreatedBy;
        query['q'] = q;

        let count = await onTopupCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await onTopupList(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const tableTitle = () => {
        return (

            <div className={classes.customToolbar}>
                <div className={classes.tableTitle}>
                    {BackButton(translations, classes.customTooltip)}
                    <Typography className={classes.typography}>{translations["topup_history"] || 'Topup History'}</Typography>
                    {hasPermission(permissions, 'topup_create') && hasPermission(permissions, 'topup_get_price_list') ? <Fab
                        variant="extended"
                        size="small"
                        color="primary"
                        aria-label="Add"
                        className={classes.fab}
                        style={{ borderRadius: '1px' }}
                        onClick={() => redirectHandler(`/topup/create?accountID=${activeAccountID}`)}
                    >
                        <Add size="small" />
                        {translations["create_new"] || "Create new"}
                    </Fab> : null}
                    <Tooltip title={translations["refresh"] || "Refresh"}>
                        <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                            <Refresh />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
        )
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`TopupHistory`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    };

    return (
        <>
            <MaterialTable
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                data={fetchTableData}
                options={tableOptions}
                localization={localization(translations)}
                onChangeRowsPerPage={(size) => {
                    pageSize = size
                }}

                onChangeColumnHidden={columnHidden}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
        </>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID,
        translations: state?.translate?.translations?.activeTranslations || {},
        permissions: state?.core?.login?.permissions || [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onTopupCount: params => dispatch(actions.fetchTopupCount(params)),
        onTopupList: params => dispatch(actions.fetchTopupList(params)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TopupHistoryList));


